interface RangeSelectionInput {
  selected: Set<string>;
  orderedIds: string[];
  targetId: string;
  anchorId: string | null;
  checked: boolean;
  shiftKey: boolean;
}

export function updateRangeSelection({
  selected,
  orderedIds,
  targetId,
  anchorId,
  checked,
  shiftKey,
}: RangeSelectionInput): Set<string> {
  const next = new Set(selected);
  const anchorIndex = anchorId ? orderedIds.indexOf(anchorId) : -1;
  const targetIndex = orderedIds.indexOf(targetId);

  if (!shiftKey || anchorIndex < 0 || targetIndex < 0) {
    if (checked) next.add(targetId);
    else next.delete(targetId);
    return next;
  }

  const start = Math.min(anchorIndex, targetIndex);
  const end = Math.max(anchorIndex, targetIndex);
  for (const id of orderedIds.slice(start, end + 1)) {
    if (checked) next.add(id);
    else next.delete(id);
  }
  return next;
}
